import { __awaiter } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { fetchLocStrings } from '@office-start/loc-service';
import { logFeature } from '@office-start/telemetry-service';
import { showStoreAppDialog } from './showStoreAppDialog';
import { getDialogURL } from './utilities/getDialogURL';
/**
 * Opens a dialog with the 'Update' capability for an app
 * @param appId Id of the app whose 'about' information is displayed
 * @returns Promise<((err: string, result: string) => void) | undefined>
 */
export const showUpgradeDialog = (appId) => __awaiter(void 0, void 0, void 0, function* () {
    logFeature({
        featureName: "MOSHub" /* KnownFeatureNames.MOSHub */,
        eventName: 'AppInstallDialog',
        params: {
            AppId: appId,
            AppCapabilities: 'OpenAppUpgradeDialog',
            DebugInfo: 'Open app upgrade dialog',
            Service: 'AppUpgradeDialogService',
        },
        area: 'MOSAppHost',
        subArea: 'UpgradeDialog',
    });
    const context = yield fetchOfficeComponentContext();
    const aboutDialogURL = getDialogURL(context, appId);
    const locStrings = yield fetchLocStrings();
    return showStoreAppDialog(appId, locStrings.metaOSHubResources.dialogAboutAppTitle, aboutDialogURL, 'UPGRADE');
});
//# sourceMappingURL=showUpgradeDialog.js.map